import React from 'react';
import { Element } from 'react-scroll';
import { LinearProgress } from '@mui/material';
import './Skillcontainer.css'

export const Skillcontainer = () => {
  return (
<Element className='skillcontainer' id='skills'>
    <div className='skillcontainer-image'>
        <img src='https://img.freepik.com/free-vector/programmer-concept-illustration_114360-2417.jpg' alt=''/>

    </div>
    <div className='skillcontainer-text'>
        <h2>SKILLS<span className='spantag'>ET</span></h2>
        <div className='skillcontainer-skillset'>
            <h5>HTML</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={90}/>
            </div>
        </div>
        <div className='skillcontainer-skillset'>
            <h5>CSS</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={85}/>
            </div>
        </div>
        <div className='skillcontainer-skillset'>
            <h5>Java Script</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={75}/>
            </div>
        </div>
        <div className='skillcontainer-skillset'>
            <h5>React</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={80}/>
            </div>
        </div>
        <div className='skillcontainer-skillset'>
            <h5>Mysql</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={70}/>
            </div>
        </div>
        <div className='skillcontainer-skillset'>
            <h5>Mongodb</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={80}/>
            </div>
        </div>
        <div className='skillcontainer-skillset'>
            <h5>AWS</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={60}/>
            </div>
        </div>
        <div className='skillcontainer-skillset'>
            <h5>Node js</h5>
            <div className='skillcontainer-slider skillcontainer-slider1'>
                <LinearProgress variant='determinate' value={80}/>
            </div>
        </div>
    </div>


</Element>  )
}
